(function (global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Lightbox = global.NewHomeSource.Lightbox || {};

  class CloseButton {
    /**
     * Initializes a new instance of the class.
     * Sets the initial state to null.
     */
    constructor() {
      this.state = null;
    }

    /**
     * Initializes the close button with the given state and binds event listeners.
     * @param {Object} state - The state object to initialize the close button with.
     * @returns {this} The current instance for chaining.
     */
    initialize(state) {
      this.state = state;
      this.bindEvents();
      return this;
    }

    /**
     * Retrieves the close button node within the root node.
     * @returns {Element} The DOM element with data-component="close"
     */
    getNode() {
      const rootNode = this.state.get('rootNode');
      return rootNode.querySelector('[data-component="close"]');
    }

    /**
     * Binds the click event listener to the close button node.
     * The event handler is bound to the current instance to ensure correct context.
     */
    bindEvents() {
      const node = this.getNode();
      this.onClick = this.onClick.bind(this);
      node.addEventListener('click', this.onClick);
    }

    /**
     * Handles the click event for the close button.
     * Notifies observers that the lightbox should be closed.
     */
    onClick() {
      this.state.notifyObservers('close');
    }

    /**
     * Removes the click event listener from the close button node.
     * Should be called to clean up event listeners when the button is no longer needed.
     */
    destroy() {
      const node = this.getNode();
      node.removeEventListener('click', this.onClick);
    }
  }

  global.NewHomeSource.Lightbox.CloseButton = CloseButton;
}(window));
